module.exports = __webpack_public_path__ + "img/chuagnjian2.5f34e690.png";